import React from 'react'
import { styled } from '@mui/material/styles'
import {
  TextField
} from '@mui/material'

import AdapterDateFns from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import DatePicker from '@mui/lab/DatePicker'
import koLocale from 'date-fns/locale/ko'

const DialogTextField = styled(TextField)({
  backgroundColor: '#fff',
  margin: '10px 0'
})

const DateForm = ({
  dataKey,
  displayName,
  form,
  disabled,
  handleChangeData,
  required,
  error,
  value = '',
  fullWidth,
  customStyle,
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={koLocale}>
      <DatePicker
        label={dataKey && displayName[dataKey].value}
        value={dataKey ? form[dataKey] : value}
        inputFormat={'yyyy-MM-dd'}
        mask={'____-__-__'}
        onChange={(newValue) => handleChangeData(dataKey, newValue)}
        disabled={disabled}
        error={error}
        size={'small'}
        renderInput={(params) => <DialogTextField 
          {...params} 
          sx={Object.assign({}, {m: 0}, customStyle)}
          size={'small'}
          disabled={disabled}
          required={required}
          error={error}
          fullWidth={fullWidth}
        />}
      />
    </LocalizationProvider>
  )
}

export default DateForm